export const SPONSORS_HAS_ERRED = 'SPONSORS_HAS_ERRED';
export const SPONSORS_FETCHED_OK = 'SPONSORS_FETCHED_OK';



// WEBPACK FOOTER //
// ./src/data/constants/sponsors.js